import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import AnalyticalStatus from "../AnalyticalNotesList/components/AnalyticalStatus/AnalyticalStatus";
import dotIcon from "@icons/ic-dot-navy-blue.svg";
import DocumentPreview from "../../Document/DocumentPreview/DocumentPreview";
import {
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  AnalyticalTitleText,
  AnalyticalTitleValue,
  WrapperStatus,
  AnalyticalWrapper,
  DocumentRow,
  DocumentInfo,
  DocumentWrppaer,
  DocumentName,
} from "./AnalyticalNoteView.styled";
import "./AnalyticalNoteView.scss";

const AnalyticalNoteView = (props) => {
  const { t, analyticalNoteInfo } = props;
  const [selectedDocument, setSelectedDocument] = useState(null);

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);
  return (
    <>
      <FormBody>
        <OptionsWrapper>
          <FlexRow>
            <SectionContainer>
              <AnalyticalWrapper>
                <AnalyticalTitleText>{t("DESCRIPTION")}</AnalyticalTitleText>
                <WrapperStatus>
                  <AnalyticalStatus status={analyticalNoteInfo.status} />
                </WrapperStatus>
              </AnalyticalWrapper>
              <AnalyticalTitleValue>
                <div
                  dangerouslySetInnerHTML={{
                    __html: analyticalNoteInfo.description,
                  }}
                ></div>
              </AnalyticalTitleValue>
              {analyticalNoteInfo.documents.length > 0 && (
                <DocumentWrppaer>
                  <AnalyticalWrapper>
                    <AnalyticalTitleText>{t("DOCUMENTS")}</AnalyticalTitleText>
                  </AnalyticalWrapper>
                  {analyticalNoteInfo.documents.map((document) => {
                    return (
                      <DocumentRow key={document.id}>
                        <DocumentInfo>
                          <DocumentName
                            onClick={() => openPreview(document)}
                            className="analytical-notes-view__download-link"
                          >
                            <Image
                              className="deleteImage"
                              src={dotIcon}
                              alt="delete"
                              styles={{ width: "auto", marginRight: "6px" }}
                            />
                            {document.fileName}
                          </DocumentName>
                        </DocumentInfo>
                      </DocumentRow>
                    );
                  })}
                </DocumentWrppaer>
              )}
            </SectionContainer>
          </FlexRow>
        </OptionsWrapper>
      </FormBody>
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

AnalyticalNoteView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AnalyticalNoteView);
